import React from "react";
import LOCAL_STORAGE from "../../../../_redux/localStorage";

export default function DatasourceSwitchIcon() {
	let oldState = LOCAL_STORAGE.loadState() || {};
	const useMocks = oldState.useMocks;

	return !useMocks ? (
		<svg
			width={16}
			height={17}
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_5033_48344)">
				<path
					d="M15.5 6V11.909L11.5 16H4.5"
					stroke="#78909C"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10.0605 10.439L12.4995 8V4L13.4995 3"
					stroke="#78909C"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M2.5 14L3.5 12V9L5.939 6.561"
					stroke="#78909C"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10.5 1H4.5L0.5 5V12"
					stroke="#78909C"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M7 7C7.82843 7 8.5 6.32843 8.5 5.5C8.5 4.67157 7.82843 4 7 4C6.17157 4 5.5 4.67157 5.5 5.5C5.5 6.32843 6.17157 7 7 7Z"
					stroke="#78909C"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M9 13C9.82843 13 10.5 12.3284 10.5 11.5C10.5 10.6716 9.82843 10 9 10C8.17157 10 7.5 10.6716 7.5 11.5C7.5 12.3284 8.17157 13 9 13Z"
					stroke="#78909C"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5033_48344">
					<rect
						width="16"
						height="16"
						fill="white"
						transform="translate(0 0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	) : (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.69 7.74C5.16341 7.26659 5.8055 7.00063 6.475 7.00063C7.1445 7.00063 7.78659 7.26659 8.26 7.74C8.73341 8.21341 8.99937 8.85549 8.99937 9.525C8.99937 10.1945 8.73341 10.8366 8.26 11.31C7.274 12.3 3.5 12.5 3.5 12.5C3.5 12.5 3.7 8.726 4.69 7.74Z"
				stroke="#78909C"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.5 0.5H1.5C1.23478 0.5 0.98043 0.605357 0.792893 0.792893C0.605357 0.98043 0.5 1.23478 0.5 1.5V14.5C0.5 14.7652 0.605357 15.0196 0.792893 15.2071C0.98043 15.3946 1.23478 15.5 1.5 15.5H14.5C14.7652 15.5 15.0196 15.3946 15.2071 15.2071C15.3946 15.0196 15.5 14.7652 15.5 14.5V6.5"
				stroke="#78909C"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.643 7.5L15.056 3.086C15.3297 2.79985 15.4804 2.41793 15.476 2.02201C15.4716 1.62608 15.3123 1.24762 15.0324 0.967644C14.7524 0.687666 14.3739 0.528423 13.978 0.524005C13.5821 0.519587 13.2002 0.670345 12.914 0.944005L8.5 5.357"
				stroke="#78909C"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
